export default "__VITE_ASSET__Bl83ZkfB__"